export default "__VITE_ASSET__3100534b__"